import React, {Fragment} from 'react';
import {Constants} from "../common/Constants";
import {StringUtility} from "../common/StringUtility";

export let SubscriptionInvoiceLinesDetail = function (props) {
    let invoiceLinesDisplay = []
    for (let v = 0; v < props.subscriptionInvoiceLines.length; v++) {
        let invoiceLine = props.subscriptionInvoiceLines[v]
        invoiceLinesDisplay.push(
            <SubscriptionInvoiceLineDetailRow
                key={v}
                index={v}
                sequenceNumber={v + 1}
                invoiceLine={invoiceLine}
            />
        )
    }

    return (
        <div className="subscription-invoice-lines-detail">
            <div className="common-form-list">
                <div className="common-form-list-header">
                    <div className="common-form-list-header-content">
                        <div className="common-form-list-row-cell number">#</div>
                        <div className="common-form-list-row-cell type">Line Type</div>
                        <div className="common-form-list-row-cell name">Label</div>
                        <div className="common-form-list-row-cell fp-service">FP Service</div>
                        <div className="common-form-list-row-cell fp-service-type">FP Service Type</div>
                        <div className="common-form-list-row-cell amount">Amount</div>
                    </div>
                </div>
                <div className="common-form-list-body">
                    {invoiceLinesDisplay}
                </div>
            </div>
        </div>
    )
}

let SubscriptionInvoiceLineDetailRow = (props) => {
    let lineType = Constants.qboInvoiceLineTypes.fpService;
    if (!props.invoiceLine.fp_service_id) {
        lineType = Constants.qboInvoiceLineTypes.custom;
    }
    return (
        <div
            id={`subscriptionInvoiceLine-${props.sequenceNumber}`}
            className="common-form-list-row"
        >
            <div className="common-form-list-row-content">
                <div className="common-form-list-row-cell number">
                    {props.sequenceNumber}
                </div>

                <div className="common-form-list-row-cell type">
                    {lineType}
                </div>

                {(() => {
                    if (lineType === Constants.qboInvoiceLineTypes.custom) {
                        return (
                            <Fragment>
                                <div className="common-form-list-row-cell name">
                                    {props.invoiceLine.name}
                                </div>
                                <div className="common-form-list-row-cell fp-service">
                                    N/A
                                </div>
                                <div className="common-form-list-row-cell fp-service-type">
                                    {props.invoiceLine.fp_service_type.name}
                                </div>
                            </Fragment>
                        )
                    } else {
                        return (
                            <Fragment>
                                <div className="common-form-list-row-cell name">
                                    {props.invoiceLine.name}
                                </div>
                                <div className="common-form-list-row-cell fp-service">
                                    {props.invoiceLine.fp_service.name}
                                </div>
                                <div className="common-form-list-row-cell fp-service-type">
                                    {props.invoiceLine.fp_service.fp_service_type.name}
                                </div>
                            </Fragment>
                        )
                    }
                })()}

                <div className="common-form-list-row-cell amount">
                    {StringUtility.stringNumberToDisplayCurrency(props.invoiceLine.amount)}
                </div>
            </div>
        </div>
    )
}
